import axios from 'axios'

const state = {
    cards: null,
    card: null
}

const getters = {
    cards (state) {
        return state.cards
    },
    card (state) {
        return state.card
    }
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async addNewCard({ dispatch }, cardObj) {
        let response = await axios.post(`/cards/newCard`, cardObj)
        if(response.data !== null){
            let userObj = { userId: cardObj.userId }
            return dispatch('myCards', userObj)
        }
        return response.data
    },
    
    async myCards({ commit }, userObj) {
        let response = await axios.post(`/cards/myPaymentCards`, userObj)
        if(response.data !== null){   
            return commit('SET_CARDS', response.data.result)
        }
    },
    
    async markCardDefault({ commit }, cardObj) {
        let response = await axios.post(`/cards/defaultCard`, cardObj)
        if(response.data !== null){
            commit('SET_CARDS', response.data.result)
        }
        return response.data
    },
    
    async deletePaymentCard({ dispatch }, cardObj) {
        let response = await axios.post(`/cards/deleteCard`, cardObj)
        if(response.data !== null){
            dispatch('myCards', cardObj)
        }
        return response.data
    },
}

const mutations = {
    SET_CARDS: (state, cards) => (state.cards = cards),
    SET_CARD: (state, cardObj) => (state.card = cardObj)
}

export default {
    state,
    getters,
    actions,
    mutations
}